// extracted by mini-css-extract-plugin
export default {"filter":"styles_filter__xJZag","text":"styles_text__c0-6q","afterFilter":"styles_afterFilter__mxvZD","filterRange":"styles_filterRange__bPfLp","close":"styles_close__V09SB"};